module.exports = __webpack_public_path__ + "static/media/HomeGraphic1.c24dad9c.jpg";